module.exports = __webpack_public_path__ + "img/4839d5b.jpg";